import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import type { StudentProgress } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';
import GET_STUDENT_PROGRESS from 'graph/queries/reports/get-student-progress-query';

export type StudentProgressState = {
  progressData?: StudentProgress;
  error: ApolloError | undefined;
  isLoading: boolean;
  refetch: () => void;
};

export type StudentProgressFilter = {
  studentId: number | number[];
  classroomId: number | number[];
};

export type StudentProgressStoreDispatch = undefined;
export type StudentProgressStore = [StudentProgressState, StudentProgressStoreDispatch];

export const getDefaultStudentProgressState = (): { __typename: string } => ({
  __typename: StoreTypename.STUDENT_PROGRESS,
});

const useStudentProgressReportStore = (characterIds?: number[]): StudentProgressStore => {
  const { data, loading, error, refetch }: QueryResult<{ studentProgress: StudentProgress }> =
    useQuery(GET_STUDENT_PROGRESS, {
      fetchPolicy: 'no-cache',
      variables: { where: { characterIds } },
    });

  return [
    {
      progressData: data?.studentProgress,
      error,
      isLoading: loading,
      refetch,
    },
    undefined,
  ];
};

export default useStudentProgressReportStore;
